import type { NonEmptyArray } from '@cast/shared-types';
import {
  Node,
  NodeMigrationStatusMigrationStatusEnum,
  NodePricing,
  WorkloadMigrationStatusMigrationStatusEnum,
  Workload,
} from '@cast/types';

import { NodeAttribute } from './_components/NodeAttributesDrawer';

export type NodeDetailsSubDrawer = 'workloads' | 'issues' | NodeAttribute;

export type ResourceUsageMetrics = {
  usage: number;
  requested: number;
  allocatable: number;
  capacity: number;
};

export type EphemeralStorageMetrics = ResourceUsageMetrics & {
  hasRequests: boolean;
  used: number;
};

export type WorkloadBaseRunningInNode = {
  name: string;
  namespace: string;
  workloadType: string;
  nodeId: string;
  nodeName: string;
  replicasPerNode: number;
  replicasOnAllNodes: number;
  resourcesPerNode: {
    requested: {
      milliCpu: number;
      memoryBytes: number;
    };
  };
  migrationStatus: WorkloadMigrationStatusMigrationStatusEnum;
  issues: NonNullable<Workload['issues']>;
};

export type NodeWithDependencies = Node & {
  pricingInfo?: NodePricing;
  workloads?: WorkloadBaseRunningInNode[];
  migrationStatus?: NodeMigrationStatusMigrationStatusEnum;
  problems?: string[];
};

export enum NodeDetailsTab {
  OVERVIEW = 'overview',
  WORKLOADS = 'workloads',
  STORAGE = 'storage',
}

export type BinPackingBlockedDetails =
  | {
      reason: 'workloads-problems';
      problematicWorkloads: NonEmptyArray<WorkloadBaseRunningInNode>;
    }
  | {
      reason: 'node-problems';
      nodeProblems: NonEmptyArray<string>;
    }
  | {
      reason: 'node-and-workloads-problems';
      nodeProblems: NonEmptyArray<string>;
      problematicWorkloads: NonEmptyArray<WorkloadBaseRunningInNode>;
    };
